import type { TLAIConversationMessage, TLAIConversationMessageAttachment, TLAIFilePreview } from '@/types/api';
import type { IconComponentProps, IconComponentType } from '@/utils/types';

export type ConversationInputForm = HTMLFormElement & {
  'chat-input': HTMLTextAreaElement;
};

export type SuggestionItem = {
  label: string;
  Icon?: IconComponentType;
};

export type ConversationInputSubmission = {
  input: string;
  attachments?: ConversationAttachment[];
  invoked_skill_slugs?: string[];
};

export enum ConversationLoadingError {
  NOT_LOADED = 'NOT_LOADED',
  NOT_FOUND = 'NOT_FOUND',
}

export enum ConversationSecondaryPanelTab {
  FILES = 'Files',
  PREVIEW = 'Preview',
  DETAILS = 'Details',
}

export type ConversationMessage = TLAIConversationMessage;

export enum ConversationAttachmentUploadStatus {
  UPLOADING = 'UPLOADING',
  ERROR = 'ERROR',
}

export type ConversationAttachment = TLAIConversationMessageAttachment & {
  uploadStatus?: ConversationAttachmentUploadStatus;
};

export type FilePreviewComponentProps<T extends TLAIFilePreview> = {
  className?: string;
  filename: string;
  file_type: string;
  preview: T;
};

export type AgentMessageGroup = {
  id: string;
  parent_message_id: string;
  messages: ConversationMessage[];
};

export type AgentToolSetupProps = {
  Icon: IconComponentType;
  iconProps?: IconComponentProps;
  className?: string;
};
